import { SIZE } from 'common/sizes';
import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const WidgetContainer = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    width:100%;
    height:${window.innerWidth<=2200?'400px':'320px'};
    background-color: #FFFFFF;
    margin: 0px 0px 0px 0px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;    
    border-radius: 5px;
`

export const EmptyStateContainer = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    width:100%;
    height: 100%;
    align-items: center;
`

export const EmptyStateMessage = styled.div`
    padding: 25px 0px 0px 0px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #343434;
    width: 249px;
    text-align: center;
`

export const EmptyStateMessage2 = styled.div`
    padding: 25px 0px 0px 0px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #343434;
    width: 312px;
    text-align: center;
`

export const WidgetTitle = styled.div`
    margin: 0px 8px 0px 0px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    padding: 4px 0px 0px 0px;
`

export const MainContainer = styled.div`
    margin: 0px 0px 0px 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
`

export const Row = styled.div`
    margin: 0px 0px 0px 0px;
    width: 100%;
    display: flex;
    flex-direction: row;
`

export const Cell = styled.div`
    width: 30%;
    text-align: left;
`

export const Cell2 = styled.div`
    width: 40%;
    text-align: left;
`

export const Cell50 = styled.div`
    width: 50%;
    text-align: left;
`

export const CellSpacer = styled.div`
    width: 10px;
`

export const InlineLeft = styled.div`
    margin: 16px 0px 20px 5px;
    display: flex;
    flex-direction: row;
    align-items: left;
    width:90%;
`

export const IconContainer = styled.div`    
    position: relative;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
`

export const ToolTipContainer = styled.div`
    position: absolute;
    width: 253px;
    z-index: 100;
    display: none;
    margin: 0px 0px 0px -185px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;

export const ToolTipContainer2 = styled.div`
    position: absolute;
    width: 290px;
    z-index: 100;
    display: none;
    margin: 0px 0px 0px -140px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;

export const ToolTipList = styled.ul`
    margin-left: 9px; 
    padding-left: 9px;
`;

export const ToolTipLabel = styled.div`
  font-family: Rubik;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
`;

export const Info = styled.div`
  cursor: pointer;
  &:hover + ${ToolTipContainer} {
    display: flex;
  }
`;

export const Info2 = styled.div`
  cursor: pointer;
  &:hover + ${ToolTipContainer2} {
    display: flex;
  }
`;

export const SectionTitle = styled.div`
    font-family: Rubik;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000;
    margin: 38px 0px 19px 0px;
`;

export const TitleToolTipContainer = styled.div`
    position: absolute;
    width: 295px;
    z-index: 100;
    display: none;
    margin: 30px 0px 0px 401px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;

export const TitleInfoIconContainer = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 38px 0px 0px 5px;
    cursor: pointer;
    &:hover + ${TitleToolTipContainer} {
        display: flex;
      }
`

export const TitleToolTipText = styled.div`
  font-family: Rubik;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;


`;



